/**
 * Route table for the admin console.
 *
 * Pages sit under a pathless Gate layout so the shell stays mounted and
 * client-side <Link> navigation does not look like a full page load.
 */
import { Routes } from "react-router";

import { appRouteTree } from "./console-routes";

export function App() {
  return <Routes>{appRouteTree}</Routes>;
}
